// import React from "react";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import FadeInOnScroll from "./FadeInOnScroll";
// import SlideInOnScroll from "./SlideInOnScroll";

// export default function OurPartnersNew() {
//   // 印尼项目伙伴列表（图片全部放在 public 根目录）
//   const indonesiaPartners = [
//     {
//       file: "DHI.png",
//       name: "DHI Indonesia",
//       description: "Our partner for Data Center hosting services",
//       url: "https://dh-indonesia.com/",
//     },
//     {
//       file: "DAI.png",
//       name: "Dimension AI",
//       description:
//         "Responsible for handling return merchandise authorization (RMA) processes, including product returns, repairs, and replacements under warranty.",
//       url: "https://dimension-ai.co/home",
//     },
//     {
//       file: "EZSVS.png",
//       name: "EZSVS",
//       description:
//         "Our partner for infrastructure cabling services, and L1 operation maintenance and support",
//       url: "https://ezsvs.com/",
//     },
//     {
//       file: "GIGA.png",
//       name: "Giga Computing",
//       description: "Our partner for GPU and CPU server solution",
//       url: "https://www.gigabyte.com/sg",
//     },
//     {
//       file: "Ruijie.png",
//       name: "RuiJie Network",
//       description: "Our partner for network switching solutions",
//       url: "https://www.ruijie.com/en-global/",
//     },
//     {
//       file: "Accelink.png",
//       name: "Accelink Technologies",
//       description:
//         "Our partner for Optical fiber connectors/adaptors (e.g. transceivers, AOC cable) and AOC racks",
//       url: "https://www.accelink.com/",
//     },
//     {
//       file: "WhiteFiber.png",
//       name: "WhiteFiber/BTBT",
//       description: "Our partner for technical consulting service",
//       url: "https://www.whitefiber.com/",
//     },
//     {
//       file: "H3C.png",
//       name: "H3C",
//       description:
//         "Our partner for providing Access controller product to manage the network switches",
//       url: "https://www.h3c.com/en/",
//     },
//     {
//       file: "Sinotrans.png",
//       name: "Sinotrans Logistics",
//       description: "Our partner for freight forwarding services",
//       url: "https://www.sinotrans.com/",
//     },
//     {
//       file: "Fiberstar.png",
//       name: "Fiberstar",
//       description: "Our partner providing circuit services",
//       url: "https://www.fiberstar.co.id/id",
//     },
//     {
//       file: "China Telecom.png",
//       name: "China Telecom Global Limited",
//       description: "Our partner providing circuit services",
//       url: "https://www.chinatelecomglobal.com/",
//     },
//     {
//       file: "Turing.png",
//       name: "Turing Agi",
//       description:
//         "Our partner for L2 service operation maintenance and support",
//       url: "https://www.turing.com/",
//     },
//   ];

//   // 时间线样式 SectionBlock（放大版 + 每条都有 FadeInOnScroll 动画）
//   const SectionBlock = ({ title, partners }) => (
//     <section>
//       <div className="text-center mb-12">
//         <h3 className="text-3xl md:text-4xl font-bold text-[#0f1643] mb-3">
//           {title}
//         </h3>
//       </div>

//       <div className="bg-white/95 rounded-3xl shadow-md border border-slate-100/70 px-8 py-12 md:px-12 md:py-14">
//         <div className="relative border-l-4 border-slate-200 ml-5 md:ml-8">
//           {partners.map((partner) => (
//             <div
//               key={partner.name}
//               className="relative pl-7 md:pl-10 pb-12 last:pb-0"
//             >
//               {/* 时间线圆点（稍微大一点） */}
//               <span className="absolute -left-[15px] top-5 w-5 h-5 rounded-full bg-white border-2 border-indigo-400 shadow" />

//               <FadeInOnScroll>
//                 <a
//                   href={partner.url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="group block cursor-pointer"
//                 >
//                   <div className="flex flex-col md:flex-row gap-5 md:gap-8 items-start">
//                     {/* Logo：固定尺寸，无边框无背景，整体放大 */}
//                     <div className="w-40 h-24 md:h-28 flex items-center justify-center shrink-0">
//                       <img
//                         src={`/${encodeURIComponent(partner.file)}`}
//                         alt={partner.name}
//                         className="object-contain max-h-24 w-full"
//                       />
//                     </div>

//                     {/* 文案：字号更大 */}
//                     <div>
//                       <h4 className="text-xl md:text-2xl font-semibold text-slate-900 mb-2 group-hover:text-indigo-600 transition">
//                         {partner.name}
//                       </h4>
//                       <p className="text-base md:text-lg text-slate-600 leading-relaxed">
//                         {partner.description}
//                       </p>
//                     </div>
//                   </div>
//                 </a>
//               </FadeInOnScroll>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );

//   return (
//     <>
//       <section className="relative overflow-hidden bg-gradient-to-br from-purple-50 via-white to-purple-100 text-[#1e0b44] py-28 md:py-32 px-6">
//         <div className="absolute -top-24 -left-24 w-80 h-80 bg-[#c6a4ff]/40 blur-[120px] rounded-full" />
//         <div className="absolute top-1/2 right-0 w-96 h-96 bg-[#8a4fff]/30 blur-[140px] rounded-full" />

//         <div className="relative z-10 max-w-6xl mx-auto text-center mb-16">
//           <FadeInOnScroll>
//             <h2 className="text-4xl md:text-5xl font-extrabold mb-2 bg-gradient-to-r from-[#6a2dd9] to-[#9a8dfc] bg-clip-text text-transparent tracking-tight">
//               OUR PARTNERS
//             </h2>
//             <p className="text-[#6b5fa9] text-lg font-medium mb-6">
//               BUILDING THE FUTURE TOGETHER
//             </p>
//             <p className="text-[#6b5fa9] text-lg font-medium">
//               Our partnerships with leading technology innovators empower us to
//               deliver advanced AI, cloud,
//               <br /> and compute infrastructure solutions to enterprises across
//               the globe. Together, we’re shaping <br />
//               the future of intelligent digital transformation.
//             </p>
//           </FadeInOnScroll>
//         </div>

//         <div className="relative z-10 max-w-6xl mx-auto">
//           <SlideInOnScroll from="left">
//             <SectionBlock
//               title="Indonesia Project – Key Partners"
//               partners={indonesiaPartners}
//             />
//           </SlideInOnScroll>
//         </div>
//       </section>
//     </>
//   );
// }
import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FadeInOnScroll from "./FadeInOnScroll";
import SlideInOnScroll from "./SlideInOnScroll";

export default function OurPartners() {
  // 全部使用 indonesiaPartners，图片都在 public 根目录
  const indonesiaPartners = [
    {
      file: "DHI.png",
      name: "DHI Indonesia",
      url: "https://dh-indonesia.com/",
    },
    {
      file: "DAI.png",
      name: "Dimension AI",
      url: "https://dimension-ai.co/home",
    },
    {
      file: "Turing.png",
      name: "Turing Agi",
      url: "https://www.turing.com/",
    },
    {
      file: "GIGA.png",
      name: "Giga Computing",
      url: "https://www.gigabyte.com/sg",
    },
    {
      file: "Ruijie.png",
      name: "RuiJie Network",
      url: "https://www.ruijie.com/en-global/",
    },
    {
      file: "Accelink.png",
      name: "Accelink Technologies",
      url: "https://www.accelink.com/",
    },
    {
      file: "WhiteFiber.png",
      name: "WhiteFiber/BTBT",
      url: "https://www.whitefiber.com/",
    },
    {
      file: "H3C.png",
      name: "H3C",
      url: "https://www.h3c.com/en/",
    },
    {
      file: "Sinotrans.png",
      name: "Sinotrans Logistics",
      url: "https://www.sinotrans.com/",
    },
    {
      file: "Fiberstar.png",
      name: "Fiberstar",
      url: "https://www.fiberstar.co.id/id",
    },
    // {
    //   file: "China Telecom.png",
    //   name: "China Telecom Global Limited",
    //   url: "https://www.chinatelecomglobal.com/",
    // },
    {
      file: "EZSVS.png",
      name: "EZSVS",
      url: "https://ezsvs.com/",
    },
    {
      file: "Nvidia.png",
      name: "Nvidea",
      url: "https://www.nvidia.com/en-us/",
    },
    {
      file: "Intel.png",
      name: "Intel",
      url: "https://www.intel.com/content/www/us/en/homepage.html",
    },
    {
      file: "amd.png",
      name: "amd",
      url: "https://www.amd.com/en.html",
    },
  ];

  // 只负责渲染 logo 的卡片区域（沿用你原本的 grid design）
  const LogoGrid = ({ partners }) => (
    <div className="bg-white/95 rounded-3xl shadow-md border border-slate-100/70 px-5 py-8 sm:px-8 sm:py-10 md:px-10 md:py-12">
      <div className="flex flex-wrap justify-center gap-6">
        {partners.map((partner, index) => (
          <a
            key={index}
            href={partner.url}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white w-40 h-24 flex items-center justify-center rounded-xl transition hover:shadow-md hover:-translate-y-1"
          >
            <img
              src={`/${encodeURIComponent(partner.file)}`} // ✅ 所有 logo 在 public 根目录
              alt={partner.name}
              width={130}
              height={80}
              className="object-contain"
            />
          </a>
        ))}
      </div>
    </div>
  );

  return (
    <>
      {/* <Navbar /> 如果需要就打开 */}

      <section className="relative overflow-hidden bg-gradient-to-br from-purple-50 via-white to-purple-100 text-[#1e0b44] py-24 md:py-28 px-6">
        <div className="absolute -top-24 -left-24 w-72 h-72 bg-[#c6a4ff]/40 blur-[120px] rounded-full" />
        <div className="absolute top-1/2 right-0 w-80 h-80 bg-[#8a4fff]/30 blur-[140px] rounded-full" />

        {/* 顶部 OUR PARTNERS 区域（文案跟原来一样） */}
        <div className="relative z-10 max-w-6xl mx-auto text-center mb-16">
          <FadeInOnScroll>
            <h2 className="text-4xl md:text-5xl font-extrabold mb-2 bg-gradient-to-r from-[#6a2dd9] to-[#9a8dfc] bg-clip-text text-transparent tracking-tight">
              OUR PARTNERS
            </h2>
            <p className="text-[#6b5fa9] text-lg font-medium mb-6">
              BUILDING THE FUTURE TOGETHER
            </p>
            <p className="text-[#6b5fa9] text-lg font-medium">
              Our partnerships with leading technology innovators empower us to
              deliver advanced AI, cloud,
              <br /> and compute infrastructure solutions to enterprises across
              the globe. Together, we’re shaping <br />
              the future of intelligent digital transformation.
            </p>
          </FadeInOnScroll>
        </div>

        <div className="relative z-10 max-w-6xl mx-auto space-y-12 md:space-y-14">
          {/* 中间的 Infrastructure / Datacenter 两段文字（照你截图原文） */}
          <FadeInOnScroll>
            <div className="text-center space-y-8">
              <div>
                <h3 className="text-2xl md:text-3xl font-bold text-[#0f1643] mb-3">
                  Infrastructure Partners
                </h3>
                <p className="text-sm md:text-base text-[#564c8a] max-w-3xl mx-auto leading-relaxed">
                  We work closely with world-class infrastructure partners to
                  power our solutions with cutting-edge compute, networking, and
                  hardware innovations. These collaborations ensure reliability,
                  efficiency, and performance at every level of deployment.
                </p>
              </div>

              <div>
                <h3 className="text-2xl md:text-3xl font-bold text-[#0f1643] mb-3">
                  Datacenter Partners
                </h3>
                <p className="text-sm md:text-base text-[#564c8a] max-w-3xl mx-auto leading-relaxed">
                  Robust infrastructure needs a solid foundation. Our global
                  Data center partners provide the secure, connected, and
                  high-availability environments essential for modern digital
                  operations.
                </p>
              </div>
            </div>
          </FadeInOnScroll>

          {/* 底部 logo 区域：用 indonesiaPartners 的图片 + 链接，样式跟原来 grid 一样 */}
          <SlideInOnScroll from="left">
            <LogoGrid partners={indonesiaPartners} />
          </SlideInOnScroll>
        </div>
      </section>

      {/* <Footer /> 如果需要就打开 */}
    </>
  );
}
